<template>
  <div class="pa-5">
    <h1>Top 10 Trending Products</h1>

    <v-row class="mt-3">
      <v-col
        cols="12"
        md="6"
      >
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  SKU
                </th>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Sold
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in products"
                :key="item.name"
                @click="
                  $router.push({
                    name: 'ProductDetail',
                    params: { id: item.product_id },
                  })
                "
              >
                <td>{{ item.product.sku | uppercase }}</td>
                <td>{{ item.product.name | uppercase }}</td>
                <td>{{ item.sold }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text>
            <column-chart
              :colors="['#2196f3']"
              :data="chart"
            />
            <pie-chart
              height="25"
              :colors="['#2196f3', 'blue']"
              :data="chart"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      products: {},
      chart: [],
    };
  },
  mounted() {
    this.getFromApi();
  },

  methods: {
    getFromApi() {
      window.axios.get("/trending-products").then((response) => {
        this.$data.products = response.data.trending;
        const stocks = this.$data.products;
        stocks.forEach((item) => {
          this.$data.chart.push([item.product.name, item.sold]);
        });
      });
    },
  },
};
</script>
